import React, { useState } from "react";
import "./SingleFileUploader.css";
import { axiosInstance } from "../../axiosInstance";
import { baseUrl } from "../../environment";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AttachFileIcon from '@mui/icons-material/AttachFile';

function SingleFileUploader() {
  const [file, setFile] = useState(null);
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  //
  const [contractParties,setContractParties] = useState({party_a: "", party_b: ""})
  const [contractType, setContractType] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
    debugger;
    const storedData = localStorage.getItem("ContractAssistData");
    if (storedData) {
        // Parse the stored JSON data
        const parseData = JSON.parse(storedData);
        const parties = JSON.parse(parseData?.contract_parties);
        setContractParties({
          party_a: parties?.party_a,
          party_b: parties?.party_b
        });
        setContractType(parseData?.contract_type);
    }
};

  const handleClose = () => {
    setOpen(false);
    navigate("/dashboard/legal-analyzer-question");
  };


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && (selectedFile.type === "application/pdf" || selectedFile.type === "application/msword" || selectedFile.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
      setFile(selectedFile);
    } else {
      toast.warn("Please upload a PDF or Word document.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleUpload = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        await axiosInstance.post(baseUrl + "Law/ClausesOfContract",formData)
        .then(res => {
          console.log(res?.data?.data);
          localStorage.setItem("ContractAssistData", JSON.stringify(res?.data?.data));
          handleClickOpen();
        })

        // if (response.ok) {
        //   alert("File uploaded successfully!");
        // } else {
        //   alert("File upload failed.");
        // }
      } catch (error) {
        alert("An error occurred. Please try again.");
      }
    }
  };

  return (
    <div className="file-uploader">
      <label className="file-upload-label" htmlFor="file-input" style={{textAlign:"center"}}>
        Choose File <AttachFileIcon />
      </label>
      <input
        id="file-input"
        type="file"
        onChange={handleFileChange}
        accept=".pdf,.doc,.docx"
        hidden
      />

      {file && (
        <div className="file-details">
          <h4>File Details:</h4>
          <ul>
            <li><strong>Name:</strong> {file.name}</li>
            <li><strong>Type:</strong> {file.type}</li>
            <li><strong>Size:</strong> {(file.size / 1024).toFixed(2)} KB</li>
          </ul>
        </div>
      )}

      <button className="upload-button" onClick={handleUpload} disabled={!file}>
        {/* Upload */}
        <CloudUploadIcon />
      </button>


      
      <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <h3>Contract Type : {contractType}</h3>
          {`Agreement Between ${contractParties?.party_a} and ${contractParties?.party_b}`}
        </DialogTitle>
        <DialogContent style={{display:"flex", alignItems: "center", justifyContent: "center"}}>
          <DialogContentText id="alert-dialog-description">
          Click "Start" to Begin
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Start
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    </div>
  );
}

export default SingleFileUploader;
